import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getEmbeddedSoftwarePath } from "@core/schema/paths/getEmbeddedSoftwarePath.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";
import { getKiosksPath } from "@core/schema/paths/getKiosksPath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getServicesDigi(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "Vývoj aplikací na míru",
			desc: `V rámci digitalizace využíváme zkušeností s vývojem a [${getWebAppsPath(tenant)}][[webových]] i mobilních aplikací, které pro vás vytvoříme na míru.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Software na míru",
			desc: `Máte nevyhovující krabicové [${getCrmPath(tenant)}}][[CRM]], nebo potřebujete přehledný ERP systém na míru? Postaráme se o to. Poradíme si také s vývojem middleware (prostředník mezi systémy).`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Integrace systémů",
			desc: `[${getIntegrationsPath(tenant)}][[Propojením firemních systémů]] vám pomůžeme skoncovat s manuálním přenášením dat, minimalizovat chyby v záznamech nebo zbavit se starostí s používáním desítek nástrojů.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Kiosková řešení",
			desc: `Vyvíjíme [${getKiosksPath(tenant)}][[kiosková řešení]] pro firmy napříč obory. Zajistíme vše od vytvoření aplikace až po napojení platebního terminálu.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Embedded software",
			desc: `[${getEmbeddedSoftwarePath(tenant)}][[Vyvíjíme vestavěný]] software na míru pro chytrá zařízení, průmyslové systémy i spotřební elektroniku.`,
			iconName: brackets,
			show: false,
		},
	];
}
